import { useCallback, useState } from "react";
import { TVerificationRequest } from "../models";
import { changeVerificationRequestStatus } from "../network";

export const useVerificationStatusChange = (
  verification_request_id: string
): [
    TVerificationRequest | null,
    boolean,
    Error | null,
    (
      action: string,
      additional?: { reason?: string; message?: string }
    ) => Promise<void>,
    React.Dispatch<React.SetStateAction<Error | null>>
  ] => {
  const [result, setResult] = useState<TVerificationRequest | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(
    async (
      action: string,
      additional?: { reason?: string; message?: string }
    ) => {
      setIsLoading(true);
      setResult(null);
      setError(null);
      try {
        const response = await changeVerificationRequestStatus(
          verification_request_id,
          action,
          additional
        );
        setResult(response);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      }
      setIsLoading(false);
    },
    [verification_request_id]
  );

  return [result, isLoading, error, request, setError];
};
